module.exports = __webpack_public_path__ + "static/poster_mod_patho-686b5155357fdf3a298a2eb89778177a.jpg";